export default "__VITE_ASSET__DazRWHRW__"